module.exports = "\nvarying vec2 f_uv;\nvarying vec3 f_normal;\nvarying vec3 f_position;\nvarying float f_border;\n\n// uv, position, projectionMatrix, modelViewMatrix, normal\nvoid main() {\n    f_uv = uv;\n    f_normal = normal;\n    f_position = position;\n    vec3 camera_ray = normalize(position - cameraPosition);\n    f_border = abs(dot(camera_ray, normal));\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/glsl/toon-vert.glsl
// module id = 39
// module chunks = 0